import { connect } from 'react-redux';
import { MappedAttributeSection } from '../../../components/questions/custom-questions/MappedAttributeSection';
import { IExternalAttributeVm } from '../../../models';
import { IApplicationState } from '../../../store';
import { ActionCreators } from '../../../store/CustomQuestionStore';

export const mapStateToProps = (state: IApplicationState) => ({
	attributes: state.clientParticipantAttributes.participantAttributes,
	selectedAttributes: state.clientParticipantAttributes.selectedAttributes,
});

export const mapDispatchToProps = (dispatch: any) => ({
	onSelect: (externalAttributeColumnName: string, attribute?: IExternalAttributeVm) => {
		dispatch(ActionCreators.HandleAttributeNameChange(externalAttributeColumnName, attribute?.attributeName));
		if (!attribute?.isMultiValue) {
			dispatch(ActionCreators.ToggleCustomResponseOptionGroupMultiple(false));
		}
	},
});

export const MappedAttributeContainer = connect(mapStateToProps, mapDispatchToProps)(MappedAttributeSection);
